module.exports = __webpack_public_path__ + "img/Truppführer_B_2.aadbde8f.svg";